<template>
    <div class="select_wrapper">
        <v-row align="center">
            <v-col
                class="d-flex"
                cols="12"
                sm="12"
            >
                <v-autocomplete
                    class="selector"
                    dense
                    filled
                    clearable
                    :items="districts"
                    v-model="selectedDistrict"
                    @change="selectedYear = null"
                    label="Select District"
                ></v-autocomplete>
            </v-col>
        </v-row>

        <v-row align="center">
            <v-col
                class="d-flex"
                cols="12"
                sm="12"
            >
                <v-autocomplete
                    class="selector"
                    dense
                    filled
                    clearable
                    :disabled="yearDisabled"
                    :items="years"
                    v-model="selectedYear"
                    label="Select Year"
                ></v-autocomplete>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import axios from 'axios';
export default {
  
    name: 'Selector',

    // Declare data this instance will use.
    data: () => ({
        // Array to contain districts in MI.
        districts: [],
        // Array to contain contract years retained on the server.
        years: [],
        selectedDistrict: null,
        selectedYear: null,
        // Year selector is disabled when a district is not selected.
        yearDisabled: true,
    }),

    // Runs upon entering the mounted lifecycle hook.
    async mounted(){
        // Make an API call to retrieve the list of districts.
        const payload = {method: 'get_districts'};

        // Await the result of the API call.
        const api_result = await axios.post(`${this.$baseAPI}common/rates_renewals/index.php`, JSON.stringify(payload), {
            headers: {'Content-Type' : 'application/json'}
        });

        // Destructure the API result.
        let result = api_result.data.result.districts;

        // Remove non-district entries and append to the districts list.
        for(let i = 0; i < result.length; i++){
            if(!(result[i] === 'Default.aspx' || result[i] === 'Styles.css')){
            this.districts.push(result[i]);
            }
        }

    },

    // Declare emitted events.
    emits: ['response'],

    // Declare methods on the instance.
    methods: {
        emitResponse(){
            // Emit a response to the parent component "App.vue".
            this.$emit('response', {district: this.selectedDistrict, year: this.selectedYear});
        },

        async getYears(){
            // Make an API call to retrieve the list of years.
            const payload = {method: 'get_years', district: this.selectedDistrict};

            // Await the result of the API call.
            const api_result = await axios.post(`${this.$baseAPI}common/rates_renewals/index.php`, JSON.stringify(payload), {
                headers: {'Content-Type' : 'application/json'}
            });

            // Destructure the API result.
            let result = api_result.data.result.years;

            // Append the result to the years array.
            for(let i = result.length - 1; i >= 0; i--){
                this.years.push(parseInt(result[i]));
            }

            // Enable the year selector.
            this.yearDisabled = false;
        },
    },

    // Declare watchers for variables on the instance.
    watch: {
        // Watch the selectedDistrict attribute for changes.
        selectedDistrict(){
            // Check if a district is still selected.
            if(this.selectedDistrict){
                // Clear the years array.
                this.years = []
                // Clear year selection.
                this.selectedYear = null
                // Make an API call to repopulate the years array.
                this.getYears()
                // Enable the year selector.
                this.yearDisabled = false;
            }else{
                // Disable the year selector.
                this.yearDisabled = true;
            }

            this.emitResponse();
        },
        selectedYear(){
            // Emit a response to the parent component "App.vue".
            this.emitResponse();
        }
    },

};
</script>

<style>
.select_wrapper{
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  margin-top: 50px;
  margin-left: 25%;
  margin-right: 50%;
  outline: black 1px solid;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 25px;
  width: 50vw
}

.selector{
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
}
</style>